import { Component } from 'react';
import { connect } from 'react-redux';

class Chameleon extends Component {

  componentWillReceiveProps(p) {
    let userEmail = localStorage.getItem('email')
    if (p.userId && userEmail) {
      window.chmln.identify(
        p.userId, {     
        email: userEmail,
      });
    }
  }
  render() {
    return null;
  }
}
const mapStateToProps = state => {
  const { userId, initd } = state;
  return {
    initd: initd,
    userId: userId,
  }
}

export default connect(mapStateToProps)(Chameleon);



// WEBPACK FOOTER //
// ./src/router/Chameleon.js